import { HttpClient } from '../../httpClient'
import { OpalApi } from '../../schema'

type CreateKeyDateV3 = OpalApi<'CreateKeyDateV3', 201>

export const createKeyDate: CreateKeyDateV3 = async (args = {}) => {
  const url = new URL('/loupe/v3/key_dates/', window.location.origin)

  return HttpClient()
    .post(url.toString(), args.requestBody)
    .then((res) => res.data)
}
